import React from 'react';
  
const Footer = () => (
  <footer className="footer">
    <p> Sandeepa Kariyawasam 2023 © </p>
  
  </footer>
);
  
export default Footer;